import { Component } from '@angular/core';

@Component({
  selector: 'app-okta-callback',
  templateUrl: './okta-callback.component.html',
  styleUrls: ['./okta-callback.component.scss']
})
export class OktaCallbackComponent {

  constructor() {
    //tslint:disable:no-empty
    //@ts-ignore
 }

}
